import React from 'react';

import ApplicationPage from 'site/application-page';
import ErrorView from 'site/error';

export default () => (
    <ApplicationPage>
        <ErrorView code={404} />
    </ApplicationPage>
);
